'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id) {
  return function (dispatch, getState) {
    var cache = getState().getIn((0, _paths.unscheduledPath)(feis_id));

    // prefer the cached version
    if (cache) return;

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id) + '/events'
      },
      types: ['GET_UNSCHEDULED_EVENTS_START', 'GET_UNSCHEDULED_EVENTS', 'GET_UNSCHEDULED_EVENTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/getUnscheduledEvents.js
// module id = 682
// module chunks = 0